/* eslint-disable no-unused-vars */
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const init = (sliderElement, paginationElement) => {
  if (!sliderElement) {
    return;
  }

  const sliderContainer = document.querySelector(sliderElement);

  if (!sliderContainer || sliderContainer.length === 0) {
    return;
  }

  const swiper = new Swiper(sliderElement, {
    breakpoints: {
      1024: {
        enabled: false,
      },
    },
    grid: {
      rows: 3,
    },
    keyboard: {
      enabled: true,
    },
    navigation: {
      enabled: true,
    },
    pagination: {
      el: paginationElement,
      clickable: true,
    },
    scrollbar: {
      enabled: false,
    },
  });
};

export default init;
